import Icon from '../components/Icon.vue'

Icon.register({
  swimmer: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M189.6 310.6C193.2 313.8 204.9 320 224 320S254.9 313.8 258.4 310.6C274.4 295.8 292.9 288 311.9 288H328.1C347.1 288 365.6 295.8 381.6 310.6 385.1 313.8 396.9 320 416 320S446.9 313.8 450.4 310.6C465.2 296.9 482.3 289.5 499.8 288.4L386.9 207.8 404.9 195C408.6 192.4 413.2 191.4 417.6 192.3L517.9 213.9C543.8 219.4 569.3 202.9 574.9 177 580.5 151.1 564 125.6 538 120L437.7 98.5C406.9 91.9 374.7 98.6 349.1 116.9L269.1 174C258.7 181.4 249.7 190.5 242.4 201L173.8 299C179.2 302.2 184.6 305.9 189.6 310.6zM624 352H608C582 352 562.2 343.6 551.9 334.1 543 325.9 532.3 320 520.1 320H503.8C491.7 320 481 325.9 472.1 334.1 461.8 343.6 442 352 416 352S370.2 343.6 359.9 334.1C351 325.9 340.3 320 328.1 320H311.8C299.7 320 289 325.9 280.1 334.1 269.8 343.6 250 352 224 352S178.2 343.6 167.9 334.1C159 325.9 148.3 320 136.1 320H119.8C107.7 320 97 325.9 88.1 334.1 77.8 343.6 58 352 32 352H16C7.2 352 0 359.2 0 368V400C0 408.8 7.2 416 16 416H32C70.6 416 104.7 403.8 128 384.2 151.3 403.8 185.4 416 224 416S296.7 403.8 320 384.2C343.3 403.8 377.4 416 416 416S488.7 403.8 512 384.2C535.3 403.8 569.4 416 608 416H624C632.8 416 640 408.8 640 400V368C640 359.2 632.8 352 624 352zM112 256C156.2 256 192 220.2 192 176S156.2 96 112 96 32 131.8 32 176 67.8 256 112 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/swimmer.js
// module id = +JDD
// module chunks = 144